import Vue from 'vue'
import Router from 'vue-router'
const loginIndex = resolve => require(['@/pages/login/index.vue'], resolve)
const home = resolve => require(['@/pages/home.vue'], resolve)
const homeIndex = resolve => require(['@/pages/home/index.vue'], resolve)
// 首页消息-更多
const moreMessageList = resolve => require(['@/pages/home/moreMessageList.vue'], resolve)
// 首页消息-消息详情
const messageDetail = resolve => require(['@/pages/home/messageDetail.vue'], resolve)
// 首页-我的待办列表
const myToDoList = resolve => require(['@/pages/home/myToDoList.vue'], resolve)
// 首页-我的申请列表
const myApplyList = resolve => require(['@/pages/home/myApplyList.vue'], resolve)
// 首页-我的已办列表
const myDoneList = resolve => require(['@/pages/home/myDoneList.vue'], resolve)
// 首页-我的待办/已办/申请---入职审批明细
const entryDetail = resolve => require(['@/pages/home/entryDetail.vue'], resolve)
const userEntryDetail = resolve => require(['@/pages/home/userEntryDetail.vue'], resolve)

// 首页-发起申请
const createApply = resolve => require(['@/pages/home/createApply.vue'], resolve)

// 工资管理-
const salary = resolve => require(['@/pages/salary/salary.vue'], resolve)
// 工资管理-其他特殊项
const otherInfo = resolve => require(['@/pages/salary/otherInfo.vue'], resolve)
// 工资管理-工资结算
const sattlement = resolve => require(['@/pages/salary/sattlement.vue'], resolve)

// 考勤管理-
const attendance = resolve => require(['@/pages/attendance/attendance.vue'], resolve)
// 考勤管理-请假列表
const leaveList = resolve => require(['@/pages/attendance/leaveList.vue'], resolve)
// 考勤管理-临时任务
const tempTaskList = resolve => require(['@/pages/attendance/tempTaskList.vue'], resolve)
// 考勤管理-考勤分析
const atndAnalysis = resolve => require(['@/pages/attendance/atndAnalysis.vue'], resolve)
// 考勤管理-考勤统计表
const atndStatis = resolve => require(['@/pages/attendance/atndStatis.vue'], resolve)
// 考勤管理-考勤汇总统计表
const atndSumStatistics = resolve => require(['@/pages/attendance/atndSumStatistics.vue'], resolve)
// 员工管理-合同管理
const contract = resolve => require(['@/pages/employeeManagement/contractInfo.vue'], resolve)

const shd = resolve => require(['@/pages/shd/shd.vue'], resolve)
// 系统管理
const systemManage = resolve => require(['@/pages/systemManage/index.vue'], resolve)
//     //角色管理
const roleManage = resolve => require(['@/pages/systemManage/roleManage/index.vue'], resolve)
const addRole = resolve => require(['@/pages/systemManage/roleManage/addRole.vue'], resolve)
const editRole = resolve => require(['@/pages/systemManage/roleManage/editRole.vue'], resolve)
//     //用户管理
//     const userManage = resolve => require(['@/pages/paperInspection/systemManage/userManage/index.vue'],resolve)
//     //菜单管理
const menuManage = resolve => require(['@/pages/systemManage/menuManage/index.vue'], resolve)
//     //菜单按钮管理
const buttonManage = resolve => require(['@/pages/systemManage/buttonManage/index.vue'], resolve)
//     //配置项管理
const configInfoManage = resolve => require(['@/pages/systemManage/configInfoManage/index.vue'], resolve)
//     //调度任务管理
const jobManage = resolve => require(['@/pages/systemManage/jobManage/index.vue'], resolve)
//     //缓存管理
const cacheManage = resolve => require(['@/pages/systemManage/cacheManage/index.vue'], resolve)
//     //数据字典
const dataDictionary = resolve => require(['@/pages/systemManage/dataDictionary/index.vue'], resolve)
// 节假日管理
const holidayManage = resolve => require(['@/pages/systemManage/holidayManage/index.vue'], resolve)
// 守护点
const shdList = resolve => require(['@/pages/shd/list.vue'], resolve)
const editStation = resolve => require(['@/pages/shd/editStation.vue'], resolve)
const addPost = resolve => require(['@/pages/shd/addPost.vue'], resolve)
const editSubStation = resolve => require(['@/pages/shd/editSubStation.vue'], resolve)

const employeeManagement = resolve => require(['@/pages/employeeManagement/index.vue'], resolve)
const organizationManage = resolve => require(['@/pages/employeeManagement/organizationManage/index.vue'], resolve)
// 用户管理
const userManage = resolve => require(['@/pages/employeeManagement/userManage/index.vue'], resolve)
// 导入用户
const addUser = resolve => require(['@/pages/employeeManagement/userManage/addUser.vue'], resolve)
// 个人信息维护
const userInfo = resolve => require(['@/pages/employeeManagement/userManage/userInfo.vue'], resolve)
// 用户详情
const detailUser = resolve => require(['@/pages/employeeManagement/userManage/detailUser.vue'], resolve)
// 人事异动分析
const personChangeAnalysis = resolve => require(['@/pages/employeeManagement/personChangeAnalysis/index.vue'], resolve)
// 消息管理
const messageManage = resolve => require(['@/pages/employeeManagement/messageManage.vue'], resolve)
Vue.use(Router)
const routes = [{
  path: '/',
  name: '登录',
  redirect: '/login'
}, {
  path: '/login',
  name: '登录',
  component: loginIndex
}, {
  path: '/home',
  name: 'home',
  component: home,
  children: [
    {
      path: 'homeIndex',
      name: '首页',
      component: homeIndex
    },
    {
      path: 'createApply',
      name: '发起申请',
      component: createApply
    },
    {
      path: 'userInfo',
      name: '个人信息维护',
      component: userInfo
    },
    {
      path: 'moreMessageList',
      name: '消息列表',
      component: moreMessageList
    }, {
      path: 'messageDetail',
      name: '消息详情',
      component: messageDetail
    }, {
      path: 'myToDoList',
      name: '我的待办',
      component: myToDoList
    }, {
      path: 'myApplyList',
      name: '我的申请',
      component: myApplyList
    }, {
      path: 'myDoneList',
      name: '我的已办',
      component: myDoneList
    }, {
      path: 'entryDetail',
      name: '入职申请',
      component: entryDetail
    }, {
      path: 'userEntryDetail',
      name: '入职申请详情',
      component: userEntryDetail
    },
	  {
      path: 'shdList',
      name: '守护点列表',
      component: shdList
    },
    {
      path: 'editStation',
      name: '编辑守护点',
      component: editStation
    },
    {
      path: 'addPost',
      name: '添加岗位',
      component: addPost
    },
    {
      path: 'editSubStation',
      name: '添加岗位',
      component: editSubStation
    },

    {
      path: 'employeeManagement',
      name: '员工管理',
      component: employeeManagement,
      meta: {
        keepAlive: true
      },
      children: [
        {
          path: 'organizationManage',
          name: 'organizationManage',
          component: organizationManage
        },
        {
          path: 'userManage',
          name: 'userManage',
          component: userManage
        },
        {
          path: 'addUser',
          name: '导入用户',
          component: addUser
        },
        {
          path: 'detailUser',
          name: '导入用户',
          component: detailUser
        },
        {
          path: 'personChangeAnalysis',
          name: '人事异动分析',
          component: personChangeAnalysis
        },
        {
          path: 'contract',
          name: '合同管理',
          component: contract
        },
        {
          path: 'messageManage',
          name: '消息管理',
          component: messageManage
        }
      ]
    },
    {
      path: 'salary',
      name: '工资管理',
      component: salary,
      children: [
        {
          path: 'otherInfo',
          name: '其他特殊项',
          component: otherInfo
        },
        {
          path: 'sattlement',
          name: '工资结算',
          component: sattlement
        }
      ]
    },
    {
      path: 'attendance',
      name: '考勤管理',
      component: attendance,
      children: [
        {
          path: 'leaveList',
          name: '请假列表',
          component: leaveList
        },
        {
          path: 'tempTaskList',
          name: '临时任务',
          component: tempTaskList
        }, {
          path: 'atndAnalysis',
          name: '考勤分析',
          component: atndAnalysis
        },
        {
          path: 'atndStatis',
          name: '考勤统计表',
          component: atndStatis
        },
        {
          path: 'atndSumStatistics',
          name: '考勤汇总统计表',
          component: atndSumStatistics
        }
      ]
    },
    {
      path: 'system',
      name: '系统管理',
      component: systemManage,
      children: [
        {
          path: 'roleManage',
          name: '角色管理',
          component: roleManage
        },
        {
          path: 'addRole',
          name: '新增角色',
          component: addRole
        },
        {
          path: 'editRole',
          name: '修改角色',
          component: editRole
        },
        {
          path: 'menuManage',
          name: '菜单管理',
          component: menuManage
        },
        {
          path: 'buttonManage',
          name: '菜单按钮管理',
          component: buttonManage
        },
        {
          path: 'configInfoManage',
          name: '配置项管理',
          component: configInfoManage
        },
        {
          path: 'jobManage',
          name: '调度任务管理',
          component: jobManage
        },
        {
          path: 'cacheManage',
          name: '缓存管理',
          component: cacheManage
        },
        {
          path: 'dataDictionary',
          name: '数据字典',
          component: dataDictionary
        },
        {
          path: 'holidayManage',
          name: '节假日管理',
          component: holidayManage
        }
      ]
    }
  ]
}
]
const router = new Router({
  routes
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js